<template>
  <div>
    <a-card v-if="queryAllEnterprise || queryManagingEnterprise" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row v-if="!viewAccountInfo && viewInnerInfo" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 14px">
                <a-input v-model="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select :allowClear="true" v-model="queryParam.installType">
                  <a-select-option v-for="item in installTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :span="6">-->
            <!--<a-form-item label="付款方式">-->
            <!--<a-select  :allowClear="true" v-model="queryParam.paymentMethod" >-->
            <!--<a-select-option v-for="item in payForList" :title="item.label" :key="item.code">-->
            <!--{{ item.label }}-->
            <!--</a-select-option>-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item label="注册星级" style="margin-left: 28px">
                <a-select v-model="queryParam.enterpriseStar">
                  <a-select-option value="1">一星</a-select-option>
                  <a-select-option value="2">二星</a-select-option>
                  <a-select-option value="3">三星</a-select-option>
                  <a-select-option value="4">四星</a-select-option>
                  <a-select-option value="5">五星</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册人" style="margin-left: 14px">
                <a-input v-model="queryParam.register" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系人">
                <a-input v-model="queryParam.enterpriseContacter" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业状态">
                <a-select :allowClear="true" v-model="queryParam.status">
                  <a-select-option v-for="item in enterpriseStatusList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :span="6">-->
            <!--<a-form-item label="结算周期">-->
            <!--<a-select  :allowClear="true" v-model="queryParam.settlementCycle" >-->
            <!--<a-select-option v-for="item in settleCycleList" :title="item.label" :key="item.code">-->
            <!--{{ item.label }}-->
            <!--</a-select-option >-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item label="企业联系方式">
                <a-input v-model="queryParam.enterpriseContactInfo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业下单">
                <a-select :allowClear="true" v-model="queryParam.enterpriseOrderLevel">
                  <a-select-option v-for="item in entImportanceTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.timeType1">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="审核时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="审核时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="">
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  v-model="queryParam.time1"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人" style="margin-left: 14px">
                <a-input v-model="queryParam.marketPrincipal" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="审核人" style="margin-left: 14px">
                <a-input v-model="queryParam.auditBy" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.timeType2">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="下单时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="合同开始时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime2"
                  v-model="queryParam.time2"
                />
              </a-form-item>
            </a-col>
            <!--<a-col :span="6" v-if="isShow == 1">-->
            <!--<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业开票" style="margin-left: 28px">-->
            <!--<a-select  :allowClear="true" v-model="queryParam.hasInvoice" >-->
            <!--<a-select-option value="1" title="是">-->
            <!--是-->
            <!--</a-select-option >-->
            <!--<a-select-option value="0" title="否">-->
            <!--否-->
            <!--</a-select-option>-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信提示" style="margin-left: 28px">
                <a-select :allowClear="true" v-model="queryParam.hasSms">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同文件">
                <a-select :allowClear="true" v-model="queryParam.hasContract">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-else-if="!viewInnerInfo && viewAccountInfo" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 28px">
                <a-input v-model="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.installType">
                  <a-select-option v-for="item in installTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="付款方式">
                <a-select :allowClear="true" v-model="queryParam.paymentMethod">
                  <a-select-option v-for="item in payForList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册星级" style="margin-left: 14px">
                <a-select v-model="queryParam.enterpriseStar">
                  <a-select-option value="1">一星</a-select-option>
                  <a-select-option value="2">二星</a-select-option>
                  <a-select-option value="3">三星</a-select-option>
                  <a-select-option value="4">四星</a-select-option>
                  <a-select-option value="5">五星</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册人" style="margin-left: 42px">
                <a-input v-model="queryParam.register" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系人">
                <a-input v-model="queryParam.enterpriseContacter" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业状态">
                <a-select :allowClear="true" v-model="queryParam.status">
                  <a-select-option v-for="item in enterpriseStatusList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="结算周期" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.settlementCycle">
                  <a-select-option v-for="item in settleCycleList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系方式">
                <a-input v-model="queryParam.enterpriseContactInfo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.timeType1">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="审核时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="审核时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="">
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  v-model="queryParam.time1"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人">
                <a-input v-model="queryParam.marketPrincipal" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="审核人" style="margin-left: 41px">
                <a-input v-model="queryParam.auditBy" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.timeType2">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="下单时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="合同开始时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime2"
                  v-model="queryParam.time2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业开票" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.hasInvoice">
                  <a-select-option v-for="item in enterpriseInvoiceMap" :key="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信提示" style="margin-left: 28px">
                <a-select :allowClear="true" v-model="queryParam.hasSms">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同文件" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.hasContract">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-else-if="!viewInnerInfo && !viewAccountInfo" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 28px">
                <a-input v-model="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.installType">
                  <a-select-option v-for="item in installTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册星级">
                <a-select v-model="queryParam.enterpriseStar">
                  <a-select-option value="1">一星</a-select-option>
                  <a-select-option value="2">二星</a-select-option>
                  <a-select-option value="3">三星</a-select-option>
                  <a-select-option value="4">四星</a-select-option>
                  <a-select-option value="5">五星</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册人" style="margin-left: 42px">
                <a-input v-model="queryParam.register" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系人">
                <a-input v-model="queryParam.enterpriseContacter" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业状态">
                <a-select :allowClear="true" v-model="queryParam.status">
                  <a-select-option v-for="item in enterpriseStatusList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系方式">
                <a-input v-model="queryParam.enterpriseContactInfo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型">
                <a-select :allowClear="true" v-model="queryParam.timeType1">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="审核时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="审核时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="">
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  v-model="queryParam.time1"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人" style="margin-left: 14px">
                <a-input v-model="queryParam.marketPrincipal" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="审核人" style="margin-left: 28px">
                <a-input v-model="queryParam.auditBy" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型">
                <a-select :allowClear="true" v-model="queryParam.timeType2">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="下单时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="合同开始时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime2"
                  v-model="queryParam.time2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信提示" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.hasSms">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同文件">
                <a-select :allowClear="true" v-model="queryParam.hasContract">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-else-if="viewInnerInfo && viewAccountInfo" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 28px">
                <a-input v-model="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.installType">
                  <a-select-option v-for="item in installTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="付款方式">
                <a-select :allowClear="true" v-model="queryParam.paymentMethod">
                  <a-select-option v-for="item in payForList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册星级">
                <a-select v-model="queryParam.enterpriseStar">
                  <a-select-option value="1">一星</a-select-option>
                  <a-select-option value="2">二星</a-select-option>
                  <a-select-option value="3">三星</a-select-option>
                  <a-select-option value="4">四星</a-select-option>
                  <a-select-option value="5">五星</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="注册人" style="margin-left: 42px">
                <a-input v-model="queryParam.register" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系人">
                <a-input v-model="queryParam.enterpriseContacter" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业状态">
                <a-select :allowClear="true" v-model="queryParam.status">
                  <a-select-option v-for="item in enterpriseStatusList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="结算周期">
                <a-select :allowClear="true" v-model="queryParam.settlementCycle">
                  <a-select-option v-for="item in settleCycleList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系方式">
                <a-input v-model="queryParam.enterpriseContactInfo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业下单" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.enterpriseOrderLevel">
                  <a-select-option v-for="item in entImportanceTypeList" :title="item.label" :key="item.code">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型">
                <a-select :allowClear="true" v-model="queryParam.timeType1">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="审核时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="审核时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="">
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  v-model="queryParam.time1"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人" style="margin-left: 14px">
                <a-input v-model="queryParam.marketPrincipal" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="审核人" style="margin-left: 28px">
                <a-input v-model="queryParam.auditBy" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="时间类型">
                <a-select :allowClear="true" v-model="queryParam.timeType2">
                  <a-select-option value="auditTime" title="审核时间">
                    审核时间
                  </a-select-option>
                  <a-select-option value="orderTime" title="下单时间">
                    下单时间
                  </a-select-option>
                  <a-select-option value="contractStartTime" title="合同开始时间">
                    合同开始时间
                  </a-select-option>
                  <a-select-option value="contractEndTime" title="合同结束时间">
                    合同结束时间
                  </a-select-option>
                  <a-select-option value="createTime" title="注册时间">
                    注册时间
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangeTime2"
                  v-model="queryParam.time2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业开票" style="margin-left: 28px">
                <a-select :allowClear="true" v-model="queryParam.hasInvoice">
                  <a-select-option v-for="item in enterpriseInvoiceMap" :key="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="短信提示" style="margin-left: 14px">
                <a-select :allowClear="true" v-model="queryParam.hasSms">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="isShow == 1">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同文件">
                <a-select :allowClear="true" v-model="queryParam.hasContract">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="isShow == 0 && viewAccountInfo" style="cursor:pointer" @click="getMore">
                <a-icon type="down-circle" theme="twoTone" style="fontSize:24px" />
              </span>
              <!--<a-divider type="vertical" />-->
              <span v-if="isShow == 1 && viewAccountInfo" style="cursor:pointer" @click="hiddenMore">
                <a-icon type="up-circle" theme="twoTone" style="fontSize:24px" />
              </span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button v-if="enterpriseList" type="primary" htmlType="submit" @click="$refs.table.refresh(true)"
                >查询</a-button
              >
              <a-button :style="{ marginLeft: '8px' }" @click="resetdata()">清空</a-button>
              <a-button v-if="downloadExcel" style="margin-left: 8px" type="primary" @click="exportEnt()"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-divider />
          <a-row :gutter="16">
            <a-col :span="9" :offset="15" :style="{ textAlign: 'right' }">
              <a-button v-if="updatePrincipal" type="primary" @click="changeMarketPrincipal()">更改负责人</a-button>
              <a-button v-if="addEnable" icon="plus" :style="{ marginLeft: '8px' }" type="primary" @click="Newprise()"
                >新增</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        labelCol="labelCol"
        wrapperCol="wrapperCol"
        :scroll="{ x: 1000 }"
        :rowSelection="{ onChange: onRowChange }"
        style="margin-top: 24px"
        bordered
      >
        <span slot="status" slot-scope="text, record">
          <td v-for="type in enterpriseStatusList" :key="type.code" v-if="record.status == type.code">
            {{ type.label }}
          </td>
        </span>
        <span slot="action" slot-scope="text, record" style="white-space: nowrap">
          <a @click="$refs.details.edit(record.enterpriseId, '1', 0)">详情</a>
          <a-divider type="vertical" />
          <a @click="$refs.details.edit(record.enterpriseId, '1', 1)">编辑</a>
          <a-divider type="vertical" />
          <span v-if="blacklist">
            <a v-if="record.status == 1" @click="showState(record.enterpriseId, record.status)">启用</a>
            <a v-else @click="showState(record.enterpriseId, record.status)">禁用</a>
            <a-divider type="vertical" />
            <a v-if="record.isBlackList == 1" @click="showStatetf(record.enterpriseId)">恢复</a>
            <a v-else @click="showStateth(record.enterpriseId)">黑名单</a>
          </span>
        </span>
      </s-table>
      <enterprise-registration ref="registration" @ok="$refs.table.refresh(true)" />
      <enterprise-details ref="details" @ok="handleOk" />
      <a-modal v-model="visible" @ok="addBlacklist(enterpriseId)">
        <a-card :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" :form="form">
              <a-form-item label="拉黑原因">
                <a-input
                  v-decorator="['removeReason', { rules: [{ required: true, message: '请输入纳入黑名单的原因' }] }]"
                />
              </a-form-item>
            </a-form>
          </div>
        </a-card>
      </a-modal>
      <a-modal v-model="marketPrincipalHidden" @ok="updateMarketPrincipal(enterpriseId)">
        <a-card :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-form-item label="市场负责人">
                <a-select v-model="marketPrincipal">
                  <a-select-option v-for="user in userMap" :key="user.userId">
                    {{ user.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
        </a-card>
      </a-modal>
    </a-card>
    <no-authority v-if="!queryAllEnterprise && !queryManagingEnterprise"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  selectFindAll,
  getEnterpriseList,
  enterpriseListDisable,
  enterpriseListEnable,
  enterpriseListPullblack,
  enterpriseListresume,
  exportEnterprise,
  updateMarketPrincipal
} from '@/api/enterprise/enterprise'
// import EnterpriseModal from './modules/EnterpriseModal'
import EnterpriseRegistration from './EnterpriseRegistration'
import EnterpriseDetails from './EnterpriseDetails'
import NoAuthority from './NoAuthority'
import { treeData } from '@/utils/treeutil'
import { findByDeptId } from '@/api/enterprise/user'
import { axios } from '@/utils/request'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'

export default {
  name: 'EnterpriseList',
  components: {
    EnterpriseDetails,
    STable,
    // EnterpriseModal,
    EnterpriseRegistration,
    NoAuthority
  },
  data() {
    return {
      isShow: 0,
      selectedEnterprise: '',
      enterpriseId: '',
      enterprise: {},
      removeReason: '',
      visible: false,
      // enterpriseList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [],
      columns1: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
          width: '60px'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          align: 'center',
          dataIndex: 'enterpriseFullName'
        },
        {
          title: '企业简称',
          align: 'center',
          dataIndex: 'enterpriseSimpleName'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align: 'center'
        },
        {
          title: '市场负责人',
          align: 'center',
          dataIndex: 'marketPrincipal'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '企业状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '总单量',
          align: 'center',
          dataIndex: 'totalOrderCount'
        },
        {
          title: '企业星级',
          align: 'center',
          dataIndex: 'enterpriseStar'
        },
        {
          title: '付款方式',
          align: 'center',
          dataIndex: 'paymentMethod'
        },
        {
          title: '结算周期',
          align: 'center',
          dataIndex: 'settlementCycle'
        },
        {
          title: '合同文件',
          align: 'center',
          dataIndex: 'hasContract'
        },
        {
          title: '合同有效期',
          align: 'center',
          dataIndex: 'contractDuration'
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'auditTime'
        },
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'auditBy'
        },
        {
          title: '注册时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '注册人',
          align: 'center',
          dataIndex: 'register'
        }
      ],
      // 没有账户信息权限
      columns2: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
          width: '60px'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          align: 'center',
          dataIndex: 'enterpriseFullName'
        },
        {
          title: '企业简称',
          align: 'center',
          dataIndex: 'enterpriseSimpleName'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align: 'center'
        },
        {
          title: '市场负责人',
          align: 'center',
          dataIndex: 'marketPrincipal'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '总单量',
          align: 'center',
          dataIndex: 'totalOrderCount'
        },
        {
          title: '企业星级',
          align: 'center',
          dataIndex: 'enterpriseStar'
        },
        {
          title: '合同文件',
          align: 'center',
          dataIndex: 'hasContract'
        },
        {
          title: '合同有效期',
          align: 'center',
          dataIndex: 'contractDuration'
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'auditTime'
        },
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'auditBy'
        },
        {
          title: '注册时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '注册人',
          align: 'center',
          dataIndex: 'register'
        }
      ],
      // 没有内部信息权限
      columns3: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
          width: '60px'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          align: 'center',
          dataIndex: 'enterpriseFullName'
        },
        {
          title: '企业简称',
          align: 'center',
          dataIndex: 'enterpriseSimpleName'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align: 'center'
        },
        {
          title: '市场负责人',
          align: 'center',
          dataIndex: 'marketPrincipal'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '总单量',
          align: 'center',
          dataIndex: 'totalOrderCount'
        },
        {
          title: '付款方式',
          align: 'center',
          dataIndex: 'paymentMethod'
        },
        {
          title: '结算周期',
          align: 'center',
          dataIndex: 'settlementCycle'
        },
        {
          title: '合同文件',
          align: 'center',
          dataIndex: 'hasContract'
        },
        {
          title: '合同有效期',
          align: 'center',
          dataIndex: 'contractDuration'
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'auditTime'
        },
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'auditBy'
        },
        {
          title: '注册时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '注册人',
          align: 'center',
          dataIndex: 'register'
        }
      ],
      // 两个都没有
      columns4: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
          width: '60px'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          align: 'center',
          dataIndex: 'enterpriseFullName'
        },
        {
          title: '企业简称',
          align: 'center',
          dataIndex: 'enterpriseSimpleName'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align: 'center'
        },
        {
          title: '市场负责人',
          align: 'center',
          dataIndex: 'marketPrincipal'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '总单量',
          align: 'center',
          dataIndex: 'totalOrderCount'
        },
        {
          title: '合同文件',
          align: 'center',
          dataIndex: 'hasContract'
        },
        {
          title: '合同有效期',
          align: 'center',
          dataIndex: 'contractDuration'
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'auditTime'
        },
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'auditBy'
        },
        {
          title: '注册时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '注册人',
          align: 'center',
          dataIndex: 'register'
        }
      ],
      selectedRowKeys: [],
      payForList: [],
      installTypeList: [],
      enterpriseStatusList: [],
      entImportanceTypeList: [],
      settleCycleList: [],
      enterpriseInvoiceMap: [],
      loading: false,
      marketPrincipal: '',
      marketPrincipalHidden: false,
      userMap: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      queryParam11: {},
      viewInnerInfo: checkPermission('viewInnerInfo'),
      addEnable: checkPermission('enterprise:enterpriseList:add'),
      enterpriseDetail: checkPermission('enterpriseDetail'),
      viewAccountInfo: checkPermission('viewAccountInfo'),
      queryAllEnterprise: checkPermission('queryAllEnterprise'),
      queryManagingEnterprise: checkPermission('queryManagingEnterprise'),
      enterpriseList: checkPermission('enterprise:enterpriseList:list'),
      blacklist: checkPermission('enterprise:enterpriseList:blacklist'),
      updatePrincipal: checkPermission('enterprise:enterpriseList:updatePrincipal'),
      downloadExcel: checkPermission('enterprise:enterpriseList:downloadExcel'),
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getEnterpriseList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  filters: {},
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    if (!this.viewAccountInfo && this.viewInnerInfo) {
      this.columns = this.columns2
    } else if (!this.viewInnerInfo && this.viewAccountInfo) {
      this.columns = this.columns3
    } else if (!this.viewAccountInfo && !this.viewInnerInfo) {
      this.columns = this.columns4
    } else if (this.viewAccountInfo && this.viewInnerInfo) {
      this.columns = this.columns1
    }
    selectFindAll({
      dictTypes: 'pay_type,install_type,enterprise_status,enterprise_importance_type,settle_cycle,enterprise_invoice'
    }).then(res => {
      // 付款方式
      this.payMap = res.pay_type
      this.payMap.forEach((value, key) => {
        this.payForList.push({ code: value.dictValue, label: value.dictLabel })
      })

      // 企业开票
      this.enterpriseInvoiceArr = res.enterprise_invoice
      this.enterpriseInvoiceArr.forEach((value, key) => {
        this.enterpriseInvoiceMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 安装类型
      this.installTypeMap = res.install_type
      this.installTypeMap.forEach((value, key) => {
        this.installTypeList.push({ code: value.dictValue, label: value.dictLabel })
      })

      // 企业状态
      this.enterpriseStatusMap = res.enterprise_status
      this.enterpriseStatusMap.forEach((value, key) => {
        this.enterpriseStatusList.push({ code: value.dictValue, label: value.dictLabel })
      })

      // 企业重要程度
      this.entImportanceTypeMap = res.enterprise_importance_type
      this.entImportanceTypeMap.forEach((value, key) => {
        this.entImportanceTypeList.push({ code: value.dictValue, label: value.dictLabel })
      })

      // 结算周期
      this.settleCycleMap = res.settle_cycle
      this.settleCycleMap.forEach((value, key) => {
        this.settleCycleList.push({ code: value.dictValue, label: value.dictLabel })
      })
    })

    // 查询用户
    await findByDeptId('104').then(res => {
      this.userMap = res
    })
  },
  methods: {
    moment,
    // 更多、隐藏
    getMore() {
      this.isShow = 1
    },
    hiddenMore() {
      this.isShow = 0
    },
    resetdata() {
      this.queryParam = {}
      this.$refs.table.refresh(true)
    },
    Newprise() {
      this.$nextTick(() => {
        this.$refs.registration.add()
      })
    },
    showStatetf(enterpriseId) {
      enterpriseListresume({ enterpriseId: enterpriseId }).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.$message.success('恢复成功')
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showStateth(enterpriseId) {
      this.visible = true
      this.form.resetFields()
      this.enterpriseId = enterpriseId
    },
    addBlacklist() {
      // e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          enterpriseListPullblack({ enterpriseId: this.enterpriseId, removeReason: values.removeReason })
            .then(res => {
              if (res.code === 0) {
                this.$message.success('拉黑成功')
                this.handleOk()
                this.visible = !this.visible
              } else {
                this.$message.error(res.msg)
              }
              this.removeReason = ''
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
      // this.visible = !this.visible
      // enterpriseListPullblack({ 'enterpriseId': this.enterpriseId, 'removeReason': this.removeReason }).then(res => {
      //   if (res.code === 0) {
      //     this.$message.success('拉黑成功')
      //     this.handleOk()
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      //   this.removeReason = ''
      // })
    },
    showState(enterpriseId, status) {
      if (status == 0) {
        enterpriseListDisable({ enterpriseId: enterpriseId }).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (status == 1) {
        enterpriseListEnable({ enterpriseId: enterpriseId }).then(res => {
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    onChangeTime1(date) {
      if (date) {
        this.queryParam.timeBegin1 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd1 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    onChangeTime2(date) {
      if (date) {
        this.queryParam.timeBegin2 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd2 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(enterpriseId) {
      this.enterpriseId = enterpriseId
    },
    handleOk() {
      this.$refs.table.refresh()
    },
    exportEnt() {
      var str = process.env.VUE_APP_API_BASE_URL + '/enterprise/management/export?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      //
      // exportEnterprise(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_企业列表'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    onRowChange(selectedRowKeys, selectedRows) {
      this.selectedEnterprise = ''
      for (let i = 0; i < selectedRows.length; i++) {
        this.selectedEnterprise = this.selectedEnterprise + ',' + selectedRows[i].enterpriseId
      }
      this.selectedEnterprise = this.selectedEnterprise.substr(1, this.selectedEnterprise.length - 1)
      // console.log(this.selectedEnterprise)
    },
    changeMarketPrincipal() {
      if (this.selectedEnterprise.length === 0) {
        this.$message.error('请至少选择一个企业')
      } else {
        this.marketPrincipalHidden = true
      }
    },
    updateMarketPrincipal() {
      if (this.marketPrincipal === '') {
        this.$message.error('请选择市场负责人')
      } else {
        updateMarketPrincipal({ enterpriseIds: this.selectedEnterprise, user: this.marketPrincipal }).then(res => {
          if (res.code === 0) {
            this.$message.success('更改成功')
            this.marketPrincipalHidden = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
.twobtn {
  background-color: #169bd5;
  color: white;
  width: 110px;
  font-size: 15px;
}
.thebtn {
  display: flex;
  justify-content: center;
}
.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}
</style>
